import type { StartupProfile } from '../types/firestore';
import { CATALOG_CATEGORY_LABELS, type CatalogCategory } from '../constants/catalog-categories';

const SKIP_FEED_TITLES = new Set<string>([
  CATALOG_CATEGORY_LABELS.previouslyViewed,
  CATALOG_CATEGORY_LABELS.yourFavorites,
  'Your favorites',
]);

/**
 * Best-effort prior badge from the investor’s visible feed: first non-meta row
 * (feed order) that currently contains the startup.
 */
export function inferCategoryFromCatalogRows(
  startup: StartupProfile,
  rows: Array<{ title: string; startups: StartupProfile[] }> | null | undefined
): CatalogCategory | undefined {
  const id = startup.id || startup.userId;
  if (!id || !rows?.length) return undefined;

  for (const row of rows) {
    if (!row.title || SKIP_FEED_TITLES.has(row.title)) continue;
    if (row.startups.some(s => (s.id || s.userId) === id)) {
      return row.title as CatalogCategory;
    }
  }
  return undefined;
}
